import { AppState } from 'pages/app/state';
import { CertaHeader, ConnectedProps } from './component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { currentOperationSelector } from 'components/menu/selectors';
import { tenantSelector } from 'pages/settings/selectors';
import { connectionSelector } from 'components/connection-status/selectors';

function mapStateToProps(state: AppState): ConnectedProps {
  return {
    isOnline: connectionSelector(state),
    currentOperation: currentOperationSelector(state),
    language: tenantSelector(state).language
  };
}

export default withRouter(connect(mapStateToProps)(CertaHeader)); 


// WEBPACK FOOTER //
// ./src/components/header/index.ts